import { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const LANGUAGES = [
  { code: "pt", label: "PT", flag: "🇵🇹" },
  { code: "en", label: "EN", flag: "🇺🇸" },
  { code: "es", label: "ES", flag: "🇪🇸" },
  { code: "fr", label: "FR", flag: "🇫🇷" },
  { code: "br", label: "BR", flag: "🇧🇷" },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("pt");
  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

export const useLanguage = () => {
  const { lang, setLang } = useContext(LanguageContext);
  return { language: lang, setLanguage: setLang };
};

export const t = (translations, lang) => translations[lang] || translations.pt;
